// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__4uvG-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2yYMy"};